import React, { useEffect, useState } from 'react';
import { Box, Typography, useTheme, } from '@mui/material';
import apiClient from '../../../services/apiClient';
import { useLocation, useNavigate } from 'react-router-dom';
import DynamicTable from '../../../components/Table/DataTable';
import { IconActivate, IconDeactivate, IconEdit, IconEye } from '../../../components/icons/icons';
import TablePaginationActions from '../../../components/Table/tablePagination';
import LoadingScreen from '../../../components/LoadingScreen';
import AddPetsModal from './Addpetmodal';

const PetsList = () => {
  const location = useLocation();
  const item = location.state?.item;
  console.log('&&&&&&&&&', item)
  const [pets, setpets] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [hasSearched, setHasSearched] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [statusFilter, setStatusFilter] = useState('');
  const [genderFilter, setGenderFilter] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [petTypeFilter, setPetTypeFilter] = useState('');
  const [petTypeOptions, setPetTypeOptions] = useState<string[]>([]);
  useEffect(() => {
    const fetchPetTypes = async () => {
      try {
        const { data } = await apiClient("v1/resource/masters/all?slug=pet-type", { method: "GET" }) as any;
        const petTypes = data?.masters?.[0]?.attributes?.values || [];
        setPetTypeOptions(petTypes);
      } catch (err) {
        console.error("Failed to load pet types", err);
      }
    };
    fetchPetTypes();
  }, []);

  const fetchpets = async () => {
    try {
      setLoading(true);
      console.log('searchQuery', searchQuery);

      const params: any = {
        limit: rowsPerPage,
        page: page + 1,
        name: searchQuery || "",
      };

      if (item?.id) {
        params.primary_id = item.id;
      }

      if (statusFilter !== "") {
        params.status = statusFilter;
      }
      if (genderFilter !== "") params.gender = genderFilter;
      if (petTypeFilter !== "") params.petType = petTypeFilter;
      const queryString = new URLSearchParams(params).toString();
      const { data } = await apiClient(`v1/resource/pet?${queryString}`, { method: "GET" }) as any;

      const petsData = data.pets;
      setpets(petsData);
      setTotalCount(data.pagination.total);
    } catch (err: any) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchpets();
  }, [searchQuery, page, rowsPerPage, statusFilter, genderFilter, petTypeFilter]);


  const handleAddClick = () => {
    setShowAddModal(true);
  };
  const handleEditClick = (row: any) => {
    setEditData(row);
    setShowAddModal(true);
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setStatusFilter(e.target.value);
    setPage(0); // reset to first page on filter change
  };
  const filteredpets = pets;

  const columns = [
    {
      key: 'serial',
      label: 'S.No',
      align: 'center',
      render: (_row: any, index: number) => page * rowsPerPage + index + 1,
    },
    {
      key: 'pet',
      label: 'Pet Name',
      align: 'center',
      render: (row: any) => {
        const pet = row?.additional_info;
        const firstLetter = pet?.name?.[0]?.toUpperCase() || '?';

        // Generate a random but consistent color based on pet name
        const colors = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#f97316'];
        const colorIndex = pet?.name ? pet.name.charCodeAt(0) % colors.length : 0;
        const bgColor = colors[colorIndex];

        return (
          <div className="flex items-center gap-2">
            {pet?.profile_image ? (
              <img
                src={pet.profile_image}
                alt={pet.name || 'Pet'}
                className="w-10 h-10 rounded-full object-cover"
              />
            ) : (
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold"
                style={{ backgroundColor: bgColor }}
              >
                {firstLetter}
              </div>
            )}
            <span>{pet?.name || '-'}</span>
          </div>
        );
      },
    },
    { key: 'species', label: 'Species', align: 'center', render: (row: any) => row?.additional_info.petType || '-' },
    { key: 'petType', label: 'Breed', align: 'center', render: (row: any) => row?.additional_info.type || '-' },
    { key: 'age', label: 'Age', align: 'center', render: (row: any) => row?.additional_info.age || '-' },
    {
      key: 'gender',
      label: 'Gender',
      align: 'center',
      render: (row: any) => {
        let gender = row?.additional_info?.gender || '-';
        gender = gender.charAt(0).toUpperCase() + gender.slice(1).toLowerCase(); // Capitalize

        let bgColor = '#e0e0e0'; // default light gray
        let textColor = 'gray';

        if (gender.toLowerCase() === 'male') {
          bgColor = '#cce5ff'; // light blue
          textColor = '#004085';
        } else if (gender.toLowerCase() === 'female') {
          bgColor = '#f8d7da'; // light pink
          textColor = '#721c24';
        } else if (gender.toLowerCase() === 'other') {
          bgColor = '#e2d6f9'; // light purple
          textColor = '#4b0082';
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              fontWeight: 'bold',
              padding: '4px 10px',
              borderRadius: '12px',
              display: 'inline-block',
              minWidth: '60px',
              textAlign: 'center',
            }}
          >
            {gender}
          </span>
        );
      },
    },
    {
      key: 'status',
      label: 'Status',
      align: 'center',
      render: (row: any) => {
        const status = row?.status ?? 'inactive'; // default to inactive

        let bgColor = '#fef3c7';
        let textColor = '#92400e';
        let statusText = 'Inactive';

        if (status === 'active') {
          bgColor = '#d1fae5';
          textColor = '#065f46';
          statusText = 'Active';
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: '4px 8px',
              borderRadius: '6px',
              fontWeight: 'bold',
              display: 'inline-block',
              minWidth: '90px',
              textAlign: 'center',
            }}
          >
            {statusText}
          </span>
        );
      },
    }

  ];


  const getUserStatusInfo = (user: any) => {
    const isActive = user?.is_active === 1;
    return {
      label: isActive ? 'Deactivate' : 'Activate',
      color: isActive ? '#d32f2f' : '#2e7d32',
      icon: isActive ? <IconDeactivate size={20} /> : <IconActivate size={20} />,
      newStatus: isActive ? 2 : 1,
    };
  };

  const actions = [
    {
      label: 'View',
      color: '#2196f3',
      icon: <IconEye size={20} />,
      onClick: (row: any) => handleShowDetails(row),
    },
    {
      label: 'Edit',
      color: '#4caf50',
      icon: <IconEdit size={20} />,
      onClick: (row: any) => handleEditClick(row),
    },
    {
      label: (row: any) => (row?.status === 'active' ? 'Deactivate' : 'Activate'),
      color: (row: any) => (row?.status === 'active' ? '#d32f2f' : '#2e7d32'),
      icon: (row: any) => (row?.status === 'active' ? <IconDeactivate /> : <IconActivate />),
      onClick: async (row: any) => {
        const actionLabel = row?.status === 'active' ? 'Deactivate' : 'Activate';
        const confirmMsg = `Are you sure you want to ${actionLabel.toLowerCase()} this pet?`;

        if (!window.confirm(confirmMsg)) {
          console.log('Action aborted');
          return;
        }

        try {
          const newStatus = row?.status === 'active' ? 'inactive' : 'active';

          await apiClient<any>(`v1/resource/pets/${row.id}`, {
            method: 'PATCH',
            body: {
              status: newStatus
            },
          });

          // Optionally update UI immediately
          row.status = newStatus;

          // Refetch pets to refresh data
          await fetchpets();
        } catch (error) {
          console.error('Failed to update status:', error);
          alert(`Failed to ${actionLabel.toLowerCase()} the pet. Please try again.`);
        }
      },
    }



  ];


  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setPage(0);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchInput]);

  if (loading) return <LoadingScreen message="Loading Pets..." layout={false} />;

  if (error) {
    return <Typography color="error">Error: {error}</Typography>;
  }


  const handleShowDetails = (item: any) => {
    const id = item.id;

    navigate(`/pets/details/${id}`, {
      state: {
        item,
        fromTab: 'pets',
      },
    });
  };

  const handleSearchClick = () => {
    setSearchQuery(searchInput);
    setPage(0);
    setHasSearched(true);
  };

  const handleClearClick = () => {
    setSearchInput('');
    setSearchQuery('');
    setHasSearched(false);
  };
  const FilterSelect = ({
    id,
    label,
    value,
    onChange,
    options,
  }: {
    id: string;
    label: string;
    value: string;
    onChange: (value: string) => void;
    options: { label: string; value: string }[];
  }) => (
    <div className="min-w-[180px] flex flex-col">
      <label
        htmlFor={id}
        className="block text-sm font-medium text-gray-700 mb-1"
      >
        {label}
      </label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 text-gray-700 rounded-md text-sm bg-white focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
  return (
    // <Layout>
    <Box >
      <Box display="flex" flexWrap="wrap" gap={2} mb={2} alignItems="flex-end">
        {/* Search Field */}
        <div className="flex gap-2 items-end flex-1 min-w-[320px]">
          <div className="flex-1">
            <label
              htmlFor="petName"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Pet Name
            </label>
            <input
              id="petName"
              type="text"
              placeholder="Search pet name"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              className="w-full px-3 py-2 border text-gray-700 border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
            />
          </div>

          {hasSearched ? (
            <button
              onClick={handleClearClick}
              className="h-[38px] px-4 bg-gray-500 text-white text-sm rounded-md hover:bg-gray-600"
            >
              Clear
            </button>
          ) : (
            <button
              onClick={handleSearchClick}
              disabled={!searchInput.trim()}
              className="h-[38px] px-4 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 disabled:bg-blue-300"
            >
              Search
            </button>
          )}
        </div>

        {/* Gender Filter */}
        <FilterSelect
          id="gender-select"
          label="Gender"
          value={genderFilter}
          onChange={(val) => {
            setGenderFilter(val);
            setPage(0);
          }}
          options={[
            { label: "All Genders", value: "" },
            { label: "Male", value: "male" },
            { label: "Female", value: "female" },
            { label: "Other", value: "other" },
          ]}
        />

        {/* Pet Type Filter */}
        <FilterSelect
          id="pet-type-select"
          label="Pet Type"
          value={petTypeFilter}
          onChange={(val) => {
            setPetTypeFilter(val);
            setPage(0);
          }}
          options={[
            { label: "All Pet Types", value: "" },
            ...petTypeOptions.map((type) => ({
              label: type.charAt(0).toUpperCase() + type.slice(1),
              value: type,
            })),
          ]}
        />

        {/* Status Filter */}
        <FilterSelect
          id="status-select"
          label="Status"
          value={statusFilter}
          onChange={(val) => {
            setStatusFilter(val);
            setPage(0);
          }}
          options={[
            { label: "All Status", value: "" },
            { label: "Active", value: "active" },
            { label: "Inactive", value: "inactive" },
          ]}
        />

        {/* Add Button */}
        <div className="flex items-end">
          <button
            onClick={handleAddClick}
            className="h-[38px] px-5 bg-green-600 text-white text-sm font-medium rounded-md hover:bg-green-700"
          >
            + Add
          </button>
        </div>
      </Box>
      <DynamicTable
        columns={columns}
        data={filteredpets}
        loading={loading}
        actions={actions}
        emptyMessage={"No pets found"}
        page={page}
        error={error}
        rowsPerPage={rowsPerPage}
        totalCount={totalCount}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        ActionsComponent={TablePaginationActions}
      />
      {showAddModal && (
        <AddPetsModal
          mode={editData ? "edit" : "add"}
          editData={editData}
          onClose={() => {
            setShowAddModal(false);
            setEditData(null);
          }}
          onSuccess={() => {
            setShowAddModal(false);
            setEditData(null);
            fetchpets();
          }}
        />
      )}

    </Box>
    // </Layout>
  );
};

export default PetsList;
